<!-- Add Store Modal -->
<div class="modal centerModalNew fade in" id="updateStore">
    <div class="modal-dialog ">
    <div class="modal-content">    
    
    
    <!-- Modal body -->
    <div class="modal-body changeimagebody">
        <div class="common billingform ">
            <div class="changeimagediv text-center mr-top-60">
                
                <form [formGroup]="store_update" (ngSubmit)="store_submit($event)">
                    <h6 class="sucssheading clrgry text-left">Add Store</h6>
                    <div class="row">
                    <div class="formrow col-md-4">
                                    <span class="upldimg">
                                        <p class="imgfrme">
                                           <span>
                                           <img [src]="Storeimage"
                           [hidden]="!Storeimage"  />
                                           </span>
                                        </p>
                                     </span>
                                     <img src="assets/images/uploadlogo.png"/>
                                      <label for="files" class="uploadlogoclass">Upload Logo</label>
                                      <input name = "Storeimage" (change)="selectImageStore($event)" accept="image/x-png,image/gif,image/jpeg" id="files" style="visibility:hidden;" type="file">
                                
                                </div>
                                
                                <div class="formrow col-md-8">
                                    <p class="brandtext text-left">Please, select the color of your  store branding,<br/> it will be for custom some emails.</p>
                                
                                <div class="formrow formrowcolorsec">
                                     <div class="text-left mbottomscolor cprimaryseccolor">
                                        <div class="primary_div">
                                            <img src="assets/images/coloricon.png"/><span class="selectcolor">Select a HEX Color</span><input class="cstm_color_picker" id="cstm_color_picker" formControlName="primary_color"
                                            id="cstm_color_new"  
                                            [cpOKButton]="true"
                                            [cpSaveClickOutside]="false"
                                            [cpOKButtonClass]= "'btn btn-primary btn-xs'"
                                            [(colorPicker)]="primary_color" autocomplete="off" readonly
                                            (colorPickerSelect)="handleChangeComplete($event)"/>
                                        </div>
                                        <div *ngIf="storeSubmitted && store_form.primary_color.invalid">
                                            <span class="inputValidation" *ngIf="store_form.primary_color.errors.required">HEX Color is required.</span>
                                    </div>
                                    
                            </div>
                                </div>
                                </div>
                            </div>
                    <div class="row">
                        <div class="form-group col-md-6">
                            <input formControlName="store_name" id="store_name" type="text"  class="form-control" placeholder="Store name">
                            <div *ngIf="storeSubmitted && store_form.store_name.invalid">
                                <span class="inputValidation" *ngIf="store_form.store_name.errors.required">Store name is required.</span>
                            </div>
                        </div>
                        <div class="form-group col-md-6">
                            <input formControlName="owner_name"  id="owner_name" type="text"  class="form-control" placeholder="Owner name">
                            <div *ngIf="storeSubmitted && store_form.owner_name.invalid">
                                <span class="inputValidation" *ngIf="store_form.owner_name.errors.required">Owner name is required.</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-6">
                            <input formControlName="contact_number" id="contact_number" type="text"  class="form-control" placeholder="Contact No.">
                            <div *ngIf="storeSubmitted && store_form.contact_number.invalid">
                                <span class="inputValidation" *ngIf="store_form.contact_number.errors.required">Contact No. is required.</span>
                            </div>
                        </div>
                        <div class="form-group col-md-6">
                            <input formControlName="email_Address"  id="email_Address" type="text"  class="form-control" placeholder="Email Address">
                            <div *ngIf="storeSubmitted && store_form.email_Address.invalid">
                                <span class="inputValidation" *ngIf="store_form.email_Address.errors.required">Email Address is required.</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-12">
                            <input formControlName="address_line1" id="address_line1" type="text"  class="form-control" placeholder="Address Line 1">
                            <div *ngIf="storeSubmitted && store_form.address_line1.invalid">
                                <span class="inputValidation" *ngIf="store_form.address_line1.errors.required">Address Line 1 is required.</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-12">
                            <input formControlName="address_line2" id="address_line2" type="text"  class="form-control" placeholder="Address Line 2">
                        </div>
                    </div>
                     <div class="row">
                        <div class="form-group col-md-6">
                            <select formControlName="country" (change)="changeStateStore($event.target.value)" name="storecountry" class="form-control" >
                                <option value="">Select Country</option>
                                    <option *ngFor="let country of countries" [value]="country.id">
                                    {{country.name}}</option>
                                </select>
                                <div *ngIf="storeSubmitted && store_form.country.invalid">
                                    <span class="inputValidation" *ngIf="store_form.country.errors.required">Country is required.</span>
                                </div>
                            
                        </div>
                        <div class="form-group col-md-6">
                            <div *ngIf="stateLoadingStore else selectStateStore">
                                <img src="assets/images/loading.gif" class="loading_gif"/>
                            </div>   
                            <ng-template #selectStateStore>
                                <select formControlName="State" class="pymntmthds form-control" id="State" autocomplete="off" >
                                    <option value="">Select State</option>
                                    <option *ngFor="let state_store of States" [value]="state_store.id">
                                    {{state_store.name}}
                                    </option>
                                </select>
                            </ng-template>
                            <div *ngIf="storeSubmitted && store_form.State.invalid">
                                <span class="inputValidation" *ngIf="store_form.State.errors.required">State is required.</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-4">
                            <input formControlName="city"  id="city" type="text"  class="form-control" placeholder="City">
                            <div *ngIf="storeSubmitted && store_form.city.invalid">
                                <span class="inputValidation" *ngIf="store_form.city.errors.required">City is required.</span>
                            </div>
                        </div>
                        <div class="form-group col-md-4">
                            <input formControlName="zip" id="zip" type="text"  class="form-control" placeholder="Zip Code">
                            <div *ngIf="storeSubmitted && store_form.zip.invalid">
                                <span class="inputValidation" *ngIf="store_form.zip.errors.required">Zip Code is required.</span>
                            </div>
                        </div>
                        <div class="form-group col-md-4">
                            <select formControlName="timezone" name="timezone" class="form-control">
                                <option value="">Select Timezone</option>
                                <option *ngFor="let timezone of timezones" [value]="timezone.name">
                                    {{timezone.gmt}}</option>
                            </select>
                            <div *ngIf="storeSubmitted && store_form.timezone.invalid">
                                <span class="inputValidation" *ngIf="store_form.timezone.errors.required">Timezone is required.</span>
                            </div>
                        </div>
                    </div>
    
                    <div class="common changenumberbttn text-left">
                        <button class="savebttn">Add</button>
                        <button class="cancelbttn close_store_modal" data-dismiss="modal">Close</button>
                      </div>
                      <div class="common text-success sccsmsgdiv" >{{store_added}}</div>
                </form>
    
            </div>
        </div>
    
    </div>
    
    
    
    </div>
    </div>
    </div>